// $('#navbar-open-mobile').on('click', function() {
//     $('#navbar-open-mobile').toggleClass('active');
//     $('body').toggleClass('overflow-hidden');
// });

$('#search-desktop .search-mobile').on('click', function() {
    $('.navbar--desktop__search').toggleClass('active');
    $('.navbar--desktop__search').find('input').on('focus');
});
